import type { ReactElement } from 'react';
import { Spinner } from '@/components/ui/Spinner';

/**
 * El SDK de Auth0 maneja el callback automáticamente vía onRedirectCallback
 * en Auth0ProviderWithNavigate. Esta página sólo muestra un loader.
 */
export function Callback(): ReactElement {
  return (
    <div className="flex h-screen items-center justify-center">
      <Spinner size="lg" label="Completando inicio de sesión…" />
    </div>
  );
}
